import { render } from "./orderinfo.vue?vue&type=template&id=89f44f60&scoped=true"
import script from "./orderinfo.vue?vue&type=script&lang=js"
export * from "./orderinfo.vue?vue&type=script&lang=js"

import "./orderinfo.vue?vue&type=style&index=0&id=89f44f60&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f44f60"]])

export default __exports__